<template>
  <section class="pt-1">
    <b-container fluid>
      <b-row class="mb-2">
        <b-col cols="12">
          <b-button variant="primary" @click="$router.push({ name: 'posts' })">
            <feather-icon
              icon="ArrowLeftIcon"
              class=""
            />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="6"
          lg="6"
          xl="6"
        >
          <b-card>
            <b-card-title class="d-flex" style="gap: 5px">
              Generate Article
              <span class="mb-0" style="font-size: 1rem;">(BETA)</span>
            </b-card-title>
            <b-form-group
              label="Number of Article"
              label-for="input-number"
            >
              <b-form-input
                id="input-number"
                placeholder="Enter a number..."
                v-model="numberOfArticles"
              />
              <small>
                <a
                  href="https://trends.google.co.id/trending?geo=ID"
                  target="_blank"
                >
                  See trends here
                </a>
              </small>
            </b-form-group>

            <b-button
              variant="primary"
              @click="repeateAgain"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add New Article</span>
            </b-button>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="6"
          xl="6"
          v-for="(item, index) in items"
          :key="index"
        >
          <b-card>
            <div class="d-flex justify-content-between">
              <b-card-title class="d-flex" style="gap: 5px">
                Generate Article
                <span class="mb-0" style="font-size: 1rem;">(BETA)</span>
              </b-card-title>
              <div>
                <b-button
                  variant="outline-danger"
                  @click="removeItem(index)"
                  size="sm"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    small
                  />
                </b-button>
              </div>
            </div>


            <b-form-group>
              <label for="">Choose Generate Content From</label>
              <b-form-select
                v-model="item.selectedGenerateTypeContent"
                :options="options"
                @change="onTypeContentChanged(item, index)"
              />
            </b-form-group>
            
            <div v-if="item.selectedGenerateTypeContent === 'link'">
              <label
                for=""
                class="mr-25"
                >Summary Of The Following Link</label
              >
              <b-input-group class="mb-1">
                <b-form-input
                  v-model="items[index].link"
                  placeholder="Enter a link..."
                />
                <template #append>
                  <button
                    class="btn btn-primary"
                    @click="generateSummarizeFromLink(index)"
                    style="text-wrap: nowrap"
                    :disabled="items[index].isLoadingSummarize || !items[index].link"
                  >
                    <div
                      class="d-flex align-items-center"
                      style="gap: 2px"
                    >
                      <b-spinner
                        v-if="items[index].isLoadingSummarize"
                        style="width: 0.9rem; height: 0.9rem"
                      />
                      <span>Summarize</span>
                    </div>
                  </button>
                </template>
              </b-input-group>
            </div>

            <div v-if="item.selectedGenerateTypeContent === 'trend'">
              <label
                for=""
                class="mr-25"
                >Generate Content</label
              >
              <b-input-group class="mb-1">
                <b-form-input
                  v-model="items[index].topic"
                  placeholder="Enter a trend or topic..."
                />
                <template #append>
                  <button
                    class="btn btn-primary"
                    @click="handleGenerateArticle(index)"
                    style="text-wrap: nowrap"
                    :disabled="items[index].isLoadingArticle || items[index].topic == ''"
                  >
                    <div
                      class="d-flex align-items-center"
                      style="gap: 2px"
                    >
                      <b-spinner
                        v-if="items[index].isLoadingArticle"
                        style="width: 0.9rem; height: 0.9rem"
                      />
                      <span>Generate Content</span>
                    </div>
                  </button>
                </template>
              </b-input-group>
            </div>

            <div
              v-if="item.selectedGenerateTypeContent === 'trend'"
              v-html="items[index].excerpt"
              class="mb-1"
            ></div>

            <div
              v-html="items[index].summaryContent"
              class="mb-1"
            ></div>

            <div
              class="mb-1"
              v-if="
                items[index].optionsTitleArticle &&
                items[index].optionsTitleArticle.length
              "
            >
              <label for="">Select Title Article</label>
              <b-form-select
                v-model="items[index].selectedTitleArticle"
                :options="items[index].optionsTitleArticle"
              />
            </div>
            <small class="text-danger">{{ item.errorMessage }}</small>
            <div
              class="d-flex flex-wrap align-items-center"
              style="gap: 5px"
            >
              <div>
                <button
                  v-if="items[index].summaryContent"
                  class="btn btn-info"
                  @click="handleGenerateContentFromSummary(index)"
                  :disabled="items[index].isLoadingSummarize"
                >
                  <div
                    class="d-flex align-items-center"
                    style="gap: 2px"
                  >
                    <b-spinner
                      v-if="items[index].isLoadingSummarize"
                      style="width: 0.9rem; height: 0.9rem"
                    />
                    <span>Generate Content</span>
                  </div>
                </button>
              </div>
              <div>
                <button
                  v-if="items[index].removedHtmlContent"
                  class="btn btn-primary"
                  @click="generateTitles(index)"
                  :disabled="items[index].isLoading"
                >
                  <div
                    class="d-flex align-items-center"
                    style="gap: 2px"
                  >
                    <b-spinner
                      v-if="items[index].isLoading"
                      style="width: 0.9rem; height: 0.9rem"
                    />
                    <span>Generate Title</span>
                  </div>
                </button>
              </div>
              <div v-if="items[index].content">
                <b-button
                  variant="outline-primary"
                  class=""
                  @click="goToDetail(index)"
                >
                  <feather-icon icon="EyeIcon" />
                  <span>&nbsp;Edit</span>
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <modal-generate-articles
      :payload="formPayload"
      @successPublishRemoveCardArticle="handleSuccessPublishRemoveCardArticle"
    />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BSpinner,
  BPagination,
  BCard,
  BFormSelect,
  BFormCheckbox,
  BFormSpinbutton,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BContainer,
  BCardTitle,
} from 'bootstrap-vue';

import {
  generateArticleContent,
  generateTitleFromContent,
  summarizeContentFromLink,
  generateContentFromSummary,
} from '@/services/geminiService';

import ModalGenerateArticles from '@/components/ModalGenerateArticles.vue';

export default {
  title() {
    return 'Generate Posts | Gemini';
  },
  components: {
    BButton,
    BSpinner,
    BPagination,
    BCard,
    BFormSelect,
    BFormCheckbox,
    BFormSpinbutton,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormGroup,
    BRow,
    BCol,
    BContainer,
    ModalGenerateArticles,
    BCardTitle,
  },
  data() {
    return {
      topic: '',
      numberOfArticles: 0,
      selectedTitleArticle: null,
      optionsTitleArticle: [],
      generateArticleNumbers: 1,
      article: null,
      items: [
        {
          isLoading: false,
          isLoadingArticle: false,
          isLoadingSummarize: false,
          id: 1,
          excerpt: '',
          title: '',
          optionsTitleArticle: [],
          selectedTitleArticle: null,
          topic: '',
          content: null,
          removedHtmlContent: null,
          summaryContent: null,
          link: null,
          selectedGenerateTypeContent: null,
          errorMessage: null
        },
      ],
      nextTodoId: 1,
      formPayload: {
        title: '',
        category: '',
        excerpt: '',
        content: '',
        is_editor_selected: false,
        is_headline: false,
        status: '',
        tags: [],
        published_at: '',
        partner: null,
        author: null,
        content_type: null,
        thumbnail: null,
        youtube_id: null,
        video: null,
        keywords: [],
      },
      selected: null,
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'trend', text: 'Generate Content From Trend' },
        { value: 'link', text: 'Generate Content From Link' },
      ],
      errorMessage: null,
      streamedData: null,
      progressData: {},
    };
  },
  watch: {},
  methods: {
    isItemBusy(index) {
      const item = this.items[index];
      return item.isLoadingArticle || item.isLoadingSummarize;
    },
    onTypeContentChanged(item, index) {
      console.log("Changed at index:", index, item.selectedGenerateTypeContent);
    },
    goToDetail(index) {
      this.formPayload = {
        title: this.items[index].selectedTitleArticle,
        content: this.items[index].content,
        excerpt: this.items[index].excerpt,
        indexArticle: this.items[index].id,
      };

      this.$bvModal.show('modal-generate-article');
    },
    async handleGenerateContentFromSummary(index) {
      try {
        this.items[index].errorMessage = null
        this.items[index].isLoadingSummarize = true
        const response = await generateContentFromSummary(this.items[index].summaryContent);
        let cleanedResponse = response.replace(/```[\s\S]*?```/g, '').trim();
        const raw = (response.match(/<p>(.*?)<\/p>/)?.[1] || '').trim();

        this.items[index].removedHtmlContent = raw;
        // Cut at 200 characters without breaking the last word
        let preview = raw.slice(0, 200);
        if (raw.length > 200) {
          // Trim to last space to avoid cutting a word
          preview = preview.slice(0, preview.lastIndexOf(' '));
          preview += '...';
        }
        this.items[index].excerpt = preview;
        this.items[index].content = cleanedResponse;
      } catch (error) {
        console.log(error, 'Error while generating content from summary');
        this.items[index].errorMessage = error
      } finally {
        this.items[index].isLoadingSummarize = false
      }
    },
    async generateSummarizeFromLink(index) {
      const item = this.items[index];

      try {
        item.errorMessage = null;
        item.isLoadingSummarize = true;
        item.summaryContent = '';

        const response = await summarizeContentFromLink(item.link);

        // this animates `summaryContent` separately
        await this.displayTextWithDelay(response, index, 'summaryContent');
      } catch (error) {
        item.errorMessage = error.message;
        console.log(error, 'Error while generating summarize from link');
      } finally {
        item.isLoadingSummarize = false;
      }
    },

    // Function to display text progressively (word by word)
    async displayTextWithDelay(text, index, key) {
      const words = text.split(' ');
      let displayedText = '';
      let isFirstWord = true;
      
      for (const word of words) {
        displayedText += (displayedText ? ' ' : '') + word;
        
        // Update the summary content in real-time
        this.items[index][key] = displayedText;
        
        // Add 1-second delay after first word, then smaller delays
        if (isFirstWord) {
          isFirstWord = false;
          await new Promise(resolve => setTimeout(resolve, 1000));
        } else {
          // Smaller delay between subsequent words (adjust as needed)
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
    },
    async generateTitles(index) {
      try {
        this.items[index].errorMessage = null
        this.items[index].isLoading = true;
        const response = await generateTitleFromContent(this.items[index].removedHtmlContent);
        // Split response into individual titles (e.g., by line or number pattern)
        this.items[index].optionsTitleArticle = [
          { value: null, text: 'Please select an option' },
          ...response
            .split(/\n+/)
            .map((line) => line.replace(/^\d+\.\s*/, '').trim())
            .filter((line) => line)
            .splice(1)
            .map((title) => ({
              value: title,
              text: title,
            })),
        ];
      } catch (e) {
        this.items[index].errorMessage = e
        this.items[index].titles = ['Failed to generate titles.'];
      } finally {
        this.items[index].isLoading = false;
      }
    },
    async handleGenerateArticle(index) {
      const item = this.items[index];

      try {
        item.errorMessage = null;
        item.isLoadingArticle = true;
        item.excerpt = '';
        item.content = '';

        const response = await generateArticleContent(item.topic);
        let cleanedResponse = response.replace(/```[\s\S]*?```/g, '').trim();
        const raw = (response.match(/<p>(.*?)<\/p>/)?.[1] || '').trim();

        item.removedHtmlContent = raw;

        // Cut at 500 chars without breaking last word
        let preview = raw.slice(0, 500);
        if (raw.length > 500) {
          preview = preview.slice(0, preview.lastIndexOf(' ')) + '...';
        }

        item.content = cleanedResponse;

        // this only animates `excerpt`
        await this.displayTextWithDelay(preview, index, 'excerpt');
      } catch (e) {
        item.errorMessage = e.message;
        console.error('Failed to generate article:', e);
      } finally {
        item.isLoadingArticle = false;
      }
    },
    repeateAgain() {
      const count = Number(this.numberOfArticles || 0);
      this.formPayload = {
        title: '',
        category: '',
        excerpt: '',
        content: '',
        is_editor_selected: false,
        is_headline: false,
        status: '',
        tags: [],
        published_at: '',
        partner: null,
        author: null,
        content_type: null,
        thumbnail: null,
        youtube_id: null,
        video: null,
        keywords: [],
      }

      for (let i = 0; i < count; i++) {
        this.nextTodoId++;
        this.items.push({
          isLoading: false,
          isLoadingArticle: false,
          isLoadingSummarize: false,
          id: this.nextTodoId,
          excerpt: '',
          title: '',
          optionsTitleArticle: [],
          selectedTitleArticle: null,
          topic: '',
          formPayload: {
            title: '',
            category: '',
            excerpt: '',
            content: '',
            is_editor_selected: false,
            is_headline: false,
            status: '',
            tags: [],
            published_at: '',
            partner: null,
            author: null,
            content_type: null,
            thumbnail: null,
            youtube_id: null,
            video: null,
            keywords: [],
          },
          selectedGenerateTypeContent: null,
          errorMessage: null
        });
      }
      this.numberOfArticles = 0;
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    handleSuccessPublishRemoveCardArticle(index) {
      this.removeItem(index - 1);
    },
  },
};
</script>
